import { useToastAutoDismiss } from '@/shared/hooks/useToastAutoDismiss';

interface ToastProps {
  message: string;
  onDismiss: () => void;
}

export function Toast({ message, onDismiss }: Readonly<ToastProps>): React.JSX.Element | null {
  useToastAutoDismiss(message, onDismiss);

  if (!message) return null;

  return (
    <output className="fixed right-6 bottom-6 z-90 rounded-lg bg-sidebar text-sidebar-foreground px-4.5 py-3 text-sm font-medium shadow-lg">
      {message}
    </output>
  );
}
